<clr-datagrid *ngIf="!!deliveries" [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'delivery_id'" [clrDgSortOrder]="descSort">Lieferschein</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_id'">Bestellnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'project'">Kunde/Betreff</clr-dg-column>
    <clr-dg-column [clrDgField]="'job_id'">Job</clr-dg-column>
    <clr-dg-column [clrDgField]="'dateI'">Datum</clr-dg-column>
    <clr-dg-column>Status</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Delivery Note!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let delivery of deliveries">
        <clr-dg-cell [routerLink]="['/delivery/details', delivery.project_id, delivery.job_id, delivery.delivery_id]">{{ delivery.project_id }}.0004.{{ delivery.delivery_id }}</clr-dg-cell>
        <clr-dg-cell>{{ delivery.order_id}}</clr-dg-cell>
        <clr-dg-cell><b>{{ delivery.company_name }}</b><br />{{ delivery.name_project }}</clr-dg-cell>
        <clr-dg-cell [routerLink]="['/job/details', delivery.project_id, delivery.job_id]">{{ delivery.project_id }}.0006.{{ delivery.job_id }}</clr-dg-cell>
        <clr-dg-cell>{{ delivery.delivery_date | date: 'dd.MM.yyyy' }}</clr-dg-cell>
        <clr-dg-cell [className]="findButtonClass(delivery.status)" role="alert">
            <div class="alert-items">
                <div class="alert-item static">
                    <div class="alert-icon-wrapper">
                        <cds-icon *ngIf="delivery.status === 'open'" class="alert-icon" shape="info-circle"></cds-icon>
                        <cds-icon *ngIf="delivery.status === 'noinvoice'" class="alert-icon" shape="exclamation-triangle"></cds-icon>
                        <cds-icon *ngIf="delivery.status === 'closed'" class="alert-icon" shape="check-circle"></cds-icon>
                    </div>
                    <span *ngIf="delivery.status === 'open'" class="alert-text">Offen</span>
                    <span *ngIf="delivery.status === 'noinvoice'" class="alert-warning">Ohne Rechnung</span>
                    <span *ngIf="delivery.status === 'closed'" class="alert-text">Gebucht</span>
                </div>
            </div>
        </clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
        <clr-dg-pagination #pagination [clrDgPageSize]="50">
            <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Lieferscheine pro Seite</clr-dg-page-size>
            {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
            von  {{ deliveries.length }} Lieferschein(en)
        </clr-dg-pagination>
    </clr-dg-footer>
</clr-datagrid>
